import DetailGroup from "../pages/group/pages/DetailGroup";
import ManageGroup from "../pages/group/pages/ManageGroup";
import NewGroup from "../pages/group/pages/NewGroup";
import EditGroup from "../pages/group/pages/EditGroup";
import GroupsMainActionPage from "../pages/group/components/actions/GroupsMainActionPage";
import ManageClientsActionPage from "../pages/group/components/actions/ManageClientsActionPage";
import DetailGroupSavings from "../pages/group/components/actions/groupSavingsApp/DetailGroupSavings";
import GroupsSavingsMainActionPage from "../pages/group/components/actions/groupSavingsApp/actions/GroupsSavingsMainActionPage";
import GsimJournalEntries from "../pages/group/components/actions/gsimApplication/childGsimAccount/tabs/transactions/GsimJournalEntries";
import DetailGroupLoan from "../pages/group/components/actions/groupLoanApplication/DetailGroupLoan";
import DetailGroupGsim from "../pages/group/components/actions/gsimApplication/DetailGroupGsim";
import GroupLoanMainActionPage from "../pages/group/components/actions/groupLoanApplication/actions/GroupLoanMainActionPage";
import RescheduleRequest from "../pages/group/components/actions/groupLoanApplication/actions/RescheduleRequest";
import ParentDetailGLIMLoan from "../pages/group/components/actions/GLIM Loan Application/ParentDetailGLIMLoan";
import ChildDetailGLIMLoan from "../pages/group/components/actions/GLIM Loan Application/ChildDetailGLIMLoan";
import GLIMLoanMainActionPage from "../pages/group/components/actions/GLIM Loan Application/actions/GLIMLoanMainActionPage";
import GsimApplicationMainActionPage from "../pages/group/components/actions/gsimApplication/actions/GsimApplicationMainActionPage";
import DetailGroupGsimAccount from "../pages/group/components/actions/gsimApplication/childGsimAccount/DetailGroupGsimAccount";
import GsimAccountMainActionPage from "../pages/group/components/actions/gsimApplication/childGsimAccount/actions/GsimAccountMainActionPage";
import ReschedulePreview from "../pages/group/components/actions/GLIM Loan Application/actions/ReschedulePreview";
import HoldAccount from "../pages/group/components/actions/gsimApplication/childGsimAccount/HoldAccount";
import GroupSavingsJournalEntries from "../pages/group/components/actions/groupSavingsApp/tabs/transactions/GroupSavingsJournalEntries";
import GroupSavingsDetailJournalEntries from "../pages/group/components/actions/groupSavingsApp/tabs/transactions/GroupSavingsDetailJournalEntries";
import ViewLoanJournalEntries from "../pages/group/components/actions/groupLoanApplication/tabs/transactions/ViewLoanJournalEntries";
import GsimAccDetailJournalEntries from "../pages/group/components/actions/gsimApplication/childGsimAccount/tabs/transactions/GsimAccDetailJournalEntries";
import GlimDetailJournalEntry from "../pages/group/components/actions/GLIM Loan Application/tabs/transactions/GlimDetailJournalEntry";

export default [
  {
    path: "/manage-group",
    component: ManageGroup,
    isProtected: true,
  },
  {
    path: "create-group",
    component: NewGroup,
    isProtected: true,
  },
  {
    path: "/detail-group",
    component: DetailGroup,
    isProtected: true,
  },
  {
    path: "/edit-group",
    component: EditGroup,
    isProtected: true,
  },
  {
    path: "/group-account-action",
    component: GroupsMainActionPage,
    isProtected: true,
  },
  {
    path: "/manage-clients-action",
    component: ManageClientsActionPage,
    isProtected: true,
  },
  {
    path: "/detail-group-savings",
    component: DetailGroupSavings,
    isProtected: true,
  },
  {
    path: "/group-savings-action",
    component: GroupsSavingsMainActionPage,
    isProtected: true,
  },
  {
    path: "/group-savings-journal-entries",
    component: GroupSavingsJournalEntries,
    isProtected: true,
  },
  {
    path: "/detail-group-savings-journal-entry",
    component: GroupSavingsDetailJournalEntries,
    isProtected: true,
  },
  {
    path: "/gsim-journal-entries",
    component: GsimJournalEntries,
    isProtected: true,
  },
  {
    path: "/detail-gsim-journal-entry",
    component: GsimAccDetailJournalEntries,
    isProtected: true,
  },
  {
    path: "/detail-group-loan",
    component: DetailGroupLoan,
    isProtected: true,
  },
  {
    path: "/group-loan-action",
    component: GroupLoanMainActionPage,
    isProtected: true,
  },
  {
    path: "/view-loan-journal-entries",
    component: ViewLoanJournalEntries,
    isProtected: true,
  },
  {
    path: "/loan-reschedule-request",
    component: RescheduleRequest,
    isProtected: true,
  },

  {
    path: "/detail-parent-glim",
    component: ParentDetailGLIMLoan,
    isProtected: true,
  },

  {
    path: "/detail-child-glim",
    component: ChildDetailGLIMLoan,
    isProtected: true,
  },

  {
    path: "/glim-loan-action",
    component: GLIMLoanMainActionPage,
    isProtected: true,
  },
  {
    path: "/glim-journal-entries",
    component: GlimDetailJournalEntry,
    isProtected: true,
  },
  {
    path: "/detail-group-gsim",
    component: DetailGroupGsim,
    isProtected: true,
  },
  {
    path: "/group-gsim-action",
    component: GsimApplicationMainActionPage,
    isProtected: true,
  },
  {
    path: "/detail-gsim-account",
    component: DetailGroupGsimAccount,
    isProtected: true,
  },
  {
    path: "/group-gsim-account-action",
    component: GsimAccountMainActionPage,
    isProtected: true,
  },
  {
    path: "/glim-loan-reschedule-preview",
    component: ReschedulePreview,
    isProtected: true,
  },
  {
    path: "/hold-account-gsim",
    component: HoldAccount,
    isProtected: true,
  },
];
